/**
 * Display-only projection of the canonical Employment Review snapshot.
 * Source of truth: GET /employees/{id}/employment-review/snapshot
 * Never derive legal approval or placement readiness from this queue.
 */
const DISPLAY_ORDER = ['application', 'work_history', 'gaps', 'cv', 'declarations'];

const normaliseOwner = (item) => {
  if (item.owner === 'admin') return 'admin';
  if (item.owner === 'applicant') return 'applicant';
  // Unknown owner is deliberately not presented as ready/verified or as
  // something staff are authorised to decide without inspecting the evidence.
  return 'unknown';
};

export function buildEmploymentReviewExceptions(snapshot) {
  // Missing canonical data must fail closed and remain obviously unavailable.
  if (!snapshot || !Array.isArray(snapshot?.summary?.items)) {
    return { available: false, admin: [], applicant: [], unknown: [], recorded: [], total: 0 };
  }
  const result = { available: true, admin: [], applicant: [], unknown: [], recorded: [], total: 0 };
  const seen = new Set();

  for (const raw of snapshot.summary.items) {
    if (!raw || !DISPLAY_ORDER.includes(raw.key) || seen.has(raw.key)) continue;
    seen.add(raw.key);
    const item = {
      key: raw.key,
      title: String(raw.title || raw.key.replace(/_/g, ' ')),
      detail: String(raw.label || 'Review the supporting evidence'),
      nextAction: typeof raw.next_action === 'string' ? raw.next_action : null,
      nextActionLabel: String(raw.next_action_label || 'Open evidence'),
      classification: raw.classification || null,
      owner: normaliseOwner(raw),
      blocking: raw.blocking !== false,
    };
    if (!item.blocking) {
      result.recorded.push(item);
    } else {
      result.total += 1;
      result[item.owner === 'admin' ? 'admin' : item.owner === 'applicant' ? 'applicant' : 'unknown'].push(item);
    }
  }
  // An incomplete snapshot cannot justify a "no outstanding actions" message.
  result.available = seen.size === DISPLAY_ORDER.length;
  return result;
}
